import request from '@/utils/request'

// 查询省市区-树结构
export function districtTree() {
    return request({
        url: '/iam/region/tree',
        method: 'get'
    })
}

// 查询菜单列表
export function listMenu(query) {
    return request({
        url: '/iam/menu/list',
        method: 'get',
        params: query
    })
}
